import Vue from 'vue'
import VeeValidate, {
    Validator
} from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN' // 引入中文文件
// 配置中文
Validator.addLocale(zh)
const config = {
    errorBagName: 'errors', // change if property conflicts.
    fieldsBagName: 'fieldBags', // 报冲突时 可自定义修改字段名称
    delay: 0, // 错误提示的延迟时间
    strict: true, // 没有设置规则的表单不进行校验，
    enableAutoClasses: false,
    locale: 'zh_CN', // 对语言（中文）的配置
    classNames: {
        touched: 'touched', // the control has been blurred
        untouched: 'untouched', // the control hasn't been blurred
        valid: 'valid', // model is valid
        invalid: 'invalid', // model is invalid
        pristine: 'pristine', // control has not been interacted with
        dirty: 'dirty' // control has been interacted with
    },
    events: 'input', //* *input|blur** 在用户输入和表单失去焦点时都进行校验 可单独写  blur或input
    inject: true
}
Vue.use(VeeValidate, config)

// 自定义validate
const dictionary = {
    zh_CN: {
		//默认提示信息
        messages: {
            // email: () => '请输入正确的邮箱格式',
            required: (field) => '请输入' + field
        },
		//自定义反规则提示---根据name
		 custom: {
				node:{
					required: (field) => '请选择' + field
				}
		},
        attributes: {
            email: '邮箱',
            phone: '手机',
            user_name: '账号',
            pass_word: '密码',
            number: '数字',
            img: '图片',
			node: '节点',
        }
    }
}

Validator.updateDictionary(dictionary)
    //手机号匹配
Validator.extend('phone', {
        messages: {
            zh_CN: field => field + '必须是11位手机号码'
        },
        validate: value => {
            return value.length === 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)
        }
    })
    //账号匹配
Validator.extend('user_name', {
        messages: {
            zh_CN: field => field + '字母开头，数字下划线组成，2-10位'
        },
        validate: value => {
            return /^([a-zA-Z][a-zA-Z0-9_]{1,9})$/.test(value)
        }
    })
    //密码匹配
Validator.extend('pass_word', {
        messages: {
            zh_CN: field => field + '字母开头，只能包含字母、数字和下划线，6-18位'
        },
        validate: value => {
            return /^([a-zA-Z]\w{5,17})$/.test(value)
        }
    })
    //高度匹配
Validator.extend('number', {
        messages: {
            zh_CN: field => '请输入数字'
        },
        validate: value => {
            return /^([0-9]*)$/.test(value)
        }
    })
    // 正整数匹配
Validator.extend('integer', {
        messages: {
            zh_CN: field => '请输入大于0的正整数'
        },
        validate: value => {
            return /^([1-9]*)$/.test(value)
        }
    })
    //图片格式匹配
Validator.extend('img', {
    messages: {
        zh_CN: field => '请上传正确的图片'
    },
    validate: value => {
        return /^(.*)\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga)$/.test(value)
    }
})
//邮箱格式匹配
Validator.extend('email', {
    messages: {
        zh_CN: field => '请输入正确的邮箱'
    },
    validate: value => {
        return /^([A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+))$/.test(value)
    }
})



// WEBPACK FOOTER //
// ./src/utils/validator.js